import React, { Fragment, useState } from "react";

import { Box, Grid, Tab, Tabs } from "@material-ui/core";

import {
  LearnerDetails,
  LessonDetails,
  Page,
  TestDetails,
} from "@hubcapp/components";
import { useTealium } from "@hubcapp/context";
import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";

import { LearnerProgress, LessonsTable } from "./components";
import { ViewLearnerProps } from "./types";
import { hasDitLearnerType } from "./utils";
import useQueryLearnerName from "./hooks/useQueryLearnerName";

const ViewLearner: React.FC<ViewLearnerProps> = ({
  learnerId,
  activeTab = "details",
}) => {
  const { data, loading } = useQueryLearnerName(learnerId);
  const [selectedTab, setSelectedTab] = useState<string>(activeTab);
  const { trackEvent } = useTealium();
  const isDit = hasDitLearnerType(data?.learner?.customerTypes ?? []);

  return (
    <Page title={`${data?.learner?.name?.fullName} | Learner`}>
      <Content>
        <PageHeader
          breadcrumbs={[
            { link: "/", title: "Home" },
            { link: "/learners", title: "Learners" },
            { title: "View learner" },
          ]}
          title={`${data?.learner?.name?.firstName} ${data?.learner?.name?.lastName}'s details`}
        />
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="auto"
          variant="scrollable"
          onChange={(e, value) => {
            setSelectedTab(value);
          }}
          aria-label="Page view tabs"
        >
          <Tab
            label="Details"
            value="details"
            data-test="view-learner-tab-details"
            aria-label="Details tab"
            onClick={() => {
              trackEvent({
                eventCategory: "View Learner",
                eventAction: "Interaction",
                eventLabel: "Details",
              });
            }}
          />
          <Tab
            label="Lesson History"
            value="lessonHistory"
            data-test="view-learner-tab-lesson-history"
            aria-label="Lesson history tab"
            onClick={() => {
              trackEvent({
                eventCategory: "View Learner",
                eventAction: "Interaction",
                eventLabel: "Lesson History",
              });
            }}
          />

          {!loading && !isDit && (
            <Tab
              label="Progress"
              value="progress"
              data-test="view-learner-tab-learner-progress"
              aria-label="Learner progress tab"
              onClick={() => {
                trackEvent({
                  eventCategory: "View Learner",
                  eventAction: "Interaction",
                  eventLabel: "Progress",
                });
              }}
            />
          )}
        </Tabs>

        <Box paddingTop={3}>
          <Grid container spacing={3}>
            {selectedTab === "details" && (
              <Fragment>
                <Grid item xs={12} md={6} lg={4}>
                  <LearnerDetails learnerId={learnerId} />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <LessonDetails learnerId={learnerId} />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TestDetails learnerId={learnerId} />
                </Grid>
              </Fragment>
            )}

            {selectedTab === "lessonHistory" && (
              <Grid item xs={12}>
                <LessonsTable learnerId={learnerId} />
              </Grid>
            )}

            {selectedTab === "progress" && (
              <Grid item xs={12}>
                <LearnerProgress learnerId={learnerId} />
              </Grid>
            )}
          </Grid>
        </Box>
      </Content>
    </Page>
  );
};
export default ViewLearner;
